import { Backdrop, Button, CircularProgress, DialogContent, Grid, Tooltip } from "@mui/material";
import FilterBar from "common/components/FilterBar/FilterBar";
import GenericAlert from "common/components/GenericAlert/GenericAlert";
import GenericDialog from "common/components/GenericDialog/GenericDialog";
import MenuActions from "common/components/MenuActions/MenuActions";
import SelectProvinceAndLocation from "common/components/SelectProvinceAndLocation/SelectProvinceAndLocation";
import { ApiService } from "common/services/ApiService";
import { useAuth } from "context/AuthContext";
import { snakeCaseObject } from "helpers/TextHelpers";
import DialogContentAssignedIn from "modules/authentication/components/ActivitiesList/DialognContentAssignedIn";
import moment from "moment";
import { useState } from "react";
import { VISIBILITY } from "utils/constants";
import DialogContentAssign from "./DialogContentAssign";
import DialogContentClone from "./DialogContentClone";
import DialogContentCreate from "./DialogContentCreate";
import { useNavigate } from "react-router-dom";

const ERROR_CODE_DUPLICATE = "1";

const ERROR_CODE_MAP = {
    [ERROR_CODE_DUPLICATE]:
        "Ya existe una actividad cargada con ese título, por favor modifíque el título de su actividad",
};

const visibilityOptions = () => [
    // {
    //     value: "",
    //     label: "Todo",
    //     show: true,
    // },
    {
        value: VISIBILITY.public,
        label: "Establecimiento",
        show: true,
    },
    {
        value: VISIBILITY.private,
        label: "Privado",
        show: true,
    },
    {
        value: VISIBILITY.community,
        label: "Comunidad",
        show: true,
    },
];

const extraFilterList = [
    {
        type: "radio",
        key: "visibility",
        items: visibilityOptions(),
    },
];

const ActivitiesList = ({ isAdmin = false, columnVisibilityModel = null }) => {
    const { auth } = useAuth();
    const navigate = useNavigate();
    const [openDialog, setOpenDialog] = useState(false);
    const [openLoader, setOpenLoader] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertText, setAlertText] = useState("");
    const [severity, setSeverity] = useState("");

    const [createContent, setCreateContent] = useState(false);
    const [updateContent, setUpdateContent] = useState(false);
    const [cloneContent, setCloneContent] = useState(false);
    const [assignContent, setAssignContent] = useState(false);
    const [showContent, setShowContent] = useState(false);
    const [deleteContent, setDeleteContent] = useState(false);
    const [assignedInContent, setAssignedInContent] = useState(false);

    const [showCancelButtonDialog, setShowCancelButtonDialog] = useState(true);
    const [showSaveButtonDialog, setShowSaveButtonDialog] = useState(true);

    const [selectedActivity, setSelectedActivity] = useState("");
    const [selectedCourse, setSelectedCourse] = useState("");

    const [modalTitle, setModalTitle] = useState("");

    const [rowCount, setRowCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [filter, setFilter] = useState("");
    const [extraFilter, setExtraFilter] = useState({});
    const [page, setPage] = useState(1);
    const [extraFilterComponent, setExtraFilterComponent] = useState({
        visibility: auth.selectedRole?.name === "superadmin" ? "" : VISIBILITY.public,
    });

    const [activities, setActivities] = useState([]);
    const [editableMode, setEditableMode] = useState(false);

    const initActivityFormData = {
        course: "",
        title: "",
        statementTitle: "",
        statement: "",
        objetive: "",
        description: "",
        dataset: "",
        graphsData: {},
        startDate: "",
        endDate: "",
        socialGrahpsEnabled: false,
        qualifyingActivity: false,
        establishment: auth.selectedEstablishment.id,
        visibility: VISIBILITY.public,
        dataSourceSelected: "staticDataSource",
        dynamicDataSource: null,
        staticDataSource: null,
    };

    const [activityFormData, setActivityFormData] = useState(initActivityFormData);

    const [activityCloneFormData, setActivityCloneFormData] = useState({
        title: selectedActivity.title,
        // description: selectedActivity.description,
        statementTitle: "",
        statement: "",
        establishment: auth.selectedEstablishment.id,
        visibility: VISIBILITY.public,
        dynamicDataSource: selectedActivity?.dynamicDataSource || null,
        staticDataSource: selectedActivity?.staticDataSource || null,
        graphsData: selectedActivity.graphs,
    });

    const [assignCourseFormData, setAssignCourseFormData] = useState({
        course: null,
        students: [],
    });

    const componentEstablishmentFilterBar = (
        <SelectProvinceAndLocation
            handleChangeProvince={() => {}}
            handleChangeLocation={() => {}}
            handleChangeEstablishment={(establishment) => {
                setExtraFilterComponent({
                    ...extraFilterComponent,
                    establishment: establishment?.id,
                });
            }}
            showEstablishments={true}
            gridSizes={{
                province: { xs: 12, lg: 4, sm: 4 },
                location: { xs: 12, lg: 4, sm: 4 },
                establishment: { xs: 12, lg: 4, sm: 4 },
            }}
        />
    );

    const extraFilterCallback = (filters) => {
        const aux = { ...filters };
        delete aux.visibility;
        delete aux.establishment;
        setExtraFilterComponent(aux);
    };

    const getActivities = async (filter = "", extraFilter = {}, page = 1, pageSize = 10) => {
        setOpenLoader(true);
        const params = {
            ...extraFilter,
            establishment:
                auth?.selectedRole?.name !== "superadmin"
                    ? extraFilter.visibility === VISIBILITY.community
                        ? extraFilterComponent.establishment
                        : auth?.selectedEstablishment?.id
                    : null,
            search: filter,
        };

        const res = await ApiService.getActivities(page, pageSize, params);

        setRowCount(res.data.count);
        setPageSize(pageSize);
        setFilter(filter);
        setExtraFilter(extraFilter);
        setPage(page);

        setActivities(
            res.data.results.map((activity) => ({
                id: activity.id,
                title: activity.title,
                description: activity.description,
                establishment: activity.establishment,
                visibility: activity.visibility,
                graphs: activity.graphs,
                staticDataSource: activity.static_data_source,
                dynamicDataSource: activity.dynamic_data_source,
                objetive: activity.objetive,
                statement: activity.statement,
                statement_title: activity.statement_title,
                hasSubjectCourseActivity: activity.has_subject_course_activity,
                owner: activity.owner,
                canClone: activity.can_clone,
                deleteInformation: activity.delete_information,
                parent: activity.parent,
                datetimeAdded: moment(activity.datetime_added).format("DD/MM/YYYY"),
            }))
        );
        setOpenLoader(false);
    };

    const showAlertFunction = (severity) => {
        setShowAlert(true);
        setSeverity(severity);
        setTimeout(() => {
            setShowAlert(false);
        }, 3000);
    };

    const handleCreateActivity = async () => {
        const auxFormData = { ...activityFormData };
        auxFormData.staticDataSource = auxFormData.staticDataSource?.id;
        const snakeCaseData = snakeCaseObject(auxFormData);

        if (
            auxFormData.title === "" ||
            auxFormData.statement_title === "" ||
            auxFormData.statement === "" ||
            auxFormData.objetive === "" ||
            auxFormData.description === "" ||
            (auxFormData.staticDataSource !== null &&
                Object.values(auxFormData.graphsData).every((value) => value === false))
        ) {
            setAlertText("Debe completar todos los campos!");
            showAlertFunction("error");
            return;
        }

        try {
            setOpenLoader(true);
            if (editableMode) {
                const idActivity = selectedActivity.id;
                await ApiService.patchActivity(idActivity, snakeCaseData);
                setAlertText("La actividad fue editada con éxito!");
            } else {
                await ApiService.createActivity(snakeCaseData);
                setAlertText("La actividad fue creada con éxito!");
            }
            setOpenLoader(false);
            getActivities(filter, extraFilter, page, pageSize);
            showAlertFunction("success");
            setOpenDialog(false);
        } catch (error) {
            const errorMessage =
                ERROR_CODE_MAP[error.response?.data.error_code] ||
                "Ocurrió un error, intente nuevamente!";
            setOpenLoader(false);
            setAlertText(errorMessage);
            showAlertFunction("error");
        }
    };

    const handleAssignCourse = async (evt) => {
        try {
            setOpenLoader(true);
            if (
                assignCourseFormData.course !== null &&
                assignCourseFormData.students.length === 0 &&
                assignCourseFormData.allStudents
            ) {
                setAlertText("El curso seleccionado no tiene estudiantes!");
                showAlertFunction("error");
                setOpenLoader(false);
                return;
            } else if (
                assignCourseFormData.course !== null &&
                assignCourseFormData.students.length === 0
            ) {
                setAlertText("Es necesario seleccionar estudiantes!");
                showAlertFunction("error");
                setOpenLoader(false);
                return;
            } else if (
                assignCourseFormData.course === null ||
                assignCourseFormData.students.length === 0
            ) {
                setAlertText("Debe completar todos los campos!");
                showAlertFunction("error");
                setOpenLoader(false);
                return;
            }
            const snakeCaseData = snakeCaseObject(assignCourseFormData);
            snakeCaseData.activity = selectedActivity.id;
            const res = await ApiService.createSubjectCourseActivity(snakeCaseData);
            if (res.status === 200) {
                setAlertText("La actividad fue asignada al curso con éxito!");
                showAlertFunction("success");
                setOpenDialog(false);
                getActivities(filter, extraFilter, page, pageSize);
            }
            setOpenLoader(false);
        } catch (error) {
            setAlertText("Ocurrió un error, intente nuevamente!");
            showAlertFunction("error");
            setOpenLoader(false);
        }
    };

    const handleCloneActivity = async (evt) => {
        try {
            const snakeCaseData = snakeCaseObject(activityCloneFormData);
            if (
                snakeCaseData.title === "" ||
                snakeCaseData.statement_title === "" ||
                snakeCaseData.statement === "" ||
                snakeCaseData.objetive === "" ||
                snakeCaseData.description === "" ||
                (snakeCaseData.graphs_data && Object.keys(snakeCaseData.graphs_data).length === 0)
            ) {
                setAlertText("Debe completar todos los campos!");
                showAlertFunction("error");
                return;
            }
            const idActivity = selectedActivity.id;
            const res = await ApiService.cloneActivity(snakeCaseData, idActivity);
            if (res.status === 200) {
                setAlertText("La actividad fue clonada con éxito!");
                showAlertFunction("success");
            }
            getActivities(filter, extraFilter, page, pageSize);
            setOpenDialog(false);
        } catch (error) {
            console.log(error);
        }
    };

    const handleDeleteActivity = async (evt) => {
        try {
            setOpenLoader(true);
            const idActivity = selectedActivity.id;
            const res = await ApiService.deleteActivity(idActivity);
            if (res.status === 200) {
                setAlertText("La actividad fue eliminada con éxito!");
                showAlertFunction("success");
                getActivities(filter, extraFilter, page, pageSize);
                setOpenDialog(false);
            }
            setOpenLoader(false);
        } catch (error) {
            setAlertText("Ocurrió un error, intente nuevamente!");
            showAlertFunction("error");
            setOpenLoader(false);
        }
    };

    const handleChangeModalContent = (setter, title) => {
        setCreateContent(false);
        setCloneContent(false);
        setAssignContent(false);
        setUpdateContent(false);
        setShowContent(false);
        setDeleteContent(false);
        setAssignedInContent(false);
        setter(true);
        setModalTitle(title);
    };

    const renderActionButtons = (params) => {
        const options = [
            {
                label: "Visualizar",
                handleClick: () => {
                    navigate(`/grapher/0/${params.row.id}`);
                },
            },
            {
                label: "Asignar a curso",
                handleClick: () => {
                    setShowCancelButtonDialog(true);
                    setShowSaveButtonDialog(true);
                    setOpenDialog(true);
                    setSelectedActivity(params.row);
                    handleChangeModalContent(
                        setAssignContent,
                        `ASIGNAR ACTIVIDAD - ${auth.selectedEstablishment.name}`
                    );
                },
            },
            {
                label: "Crear a partir de ...",
                handleClick: () => {
                    setShowCancelButtonDialog(true);
                    setShowSaveButtonDialog(true);
                    setOpenDialog(true);
                    setSelectedActivity(params.row);
                    handleChangeModalContent(
                        setCloneContent,
                        `CREAR A PARTIR DE LA ACTIVIDAD - ${auth.selectedEstablishment.name}`
                    );
                },
                tooltipTitle: !params.row.canClone
                    ? "Esta actividad no se pude crear por que el dueño del dataset decidió archivar el dataset"
                    : "",
                disabled: !params.row.canClone,
            },
            {
                label: "Cursos asignados",
                handleClick: () => {
                    setShowCancelButtonDialog(false);
                    setShowSaveButtonDialog(false);
                    setOpenDialog(true);
                    setSelectedActivity(params.row);
                    handleChangeModalContent(
                        setAssignedInContent,
                        `CURSOS ASIGNADOS - ${auth.selectedEstablishment.name}`
                    );
                },
                tooltipTitle:
                    params.row.deleteInformation?.course_list.length === 0
                        ? "Esta actividad no está asignada a ningún curso"
                        : "",
                disabled: params.row.deleteInformation?.course_list.length === 0,
            },
            {
                label: "Editar",
                handleClick: () => {
                    setShowCancelButtonDialog(true);
                    setShowSaveButtonDialog(true);
                    setSelectedActivity(params.row);
                    setActivityFormData({
                        title: params.row.title,
                        statementTitle: params.row.statement_title,
                        statement: params.row.statement,
                        visibility: params.row.visibility,
                        objetive: params.row.objetive,
                        description: params.row.description,
                        graphsData: params.row.graphs?.reduce(
                            (acc, key) => ({ ...acc, [key]: true }),
                            {}
                        ),
                        staticDataSource: params.row.staticDataSource,
                        dynamicDataSource: params.row.dynamicDataSource?.id,
                    });
                    setOpenDialog(true);
                    setEditableMode(true);
                    handleChangeModalContent(
                        setUpdateContent,
                        `EDITAR ACTIVIDAD - ${auth.selectedEstablishment.name}`
                    );
                },
                disabled: params.row.hasSubjectCourseActivity,
            },
            {
                label: "Eliminar",
                handleClick: () => {
                    setShowCancelButtonDialog(true);
                    setShowSaveButtonDialog(true);
                    setOpenDialog(true);
                    setSelectedActivity(params.row);
                    handleChangeModalContent(
                        setDeleteContent,
                        `ELIMINAR ACTIVIDAD - ${auth.selectedEstablishment.name}`
                    );
                },
                tooltipTitle:
                    params.row.deleteInformation?.sar_delivered_list.length > 0
                        ? "La actividad que usted desea eliminar tiene entregas pendientes de corrección y/o correcciones realizadas. No es posible eliminarla"
                        : "",
                disabled: params.row.deleteInformation?.sar_delivered_list.length > 0,
            },

            {
                label: "Ver Info",
                handleClick: () => {
                    setShowCancelButtonDialog(false);
                    setShowSaveButtonDialog(false);
                    setOpenDialog(true);
                    setSelectedActivity(params.row);
                    handleChangeModalContent(
                        setShowContent,
                        `INFORMACIÓN DE LA ACTIVIDAD - ${auth.selectedEstablishment.name}`
                    );
                },
            },
        ];
        return <MenuActions options={options} />;
    };

    const activitiesColumns = [
        {
            field: "title",
            headerName: "Titulo",
            width: 150,
            renderCell: (params) => (
                <Tooltip title={params.row.title}>
                    <p>{params.row.title}</p>
                </Tooltip>
            ),
        },
        {
            field: "description",
            headerName: "Descripción",
            width: 150,
            renderCell: (params) => (
                <Tooltip title={params.row.description}>
                    <p>{params.row.description}</p>
                </Tooltip>
            ),
        },
        {
            field: "establishment",
            headerName: "Establecimiento",
            width: 450,
            renderCell: (params) => (
                <Tooltip title={params.row.establishment}>
                    <p style={{ overflow: "hidden" }}>{params.row.establishment}</p>
                </Tooltip>
            ),
        },
        {
            field: "actions",
            headerName: "Acciones",
            width: 200,
            hideable: true,
            renderCell: renderActionButtons,
        },
    ];

    return (
        <Grid container spacing={2} sx={{ flexDirection: "column" }}>
            <Grid item xs={12}>
                <h1>Actividades</h1>
            </Grid>
            <Grid item xs={12}>
                <Button
                    variant="contained"
                    mb={3}
                    onClick={() => {
                        setOpenDialog(true);
                        setShowCancelButtonDialog(true);
                        setShowSaveButtonDialog(true);
                        setActivityFormData(initActivityFormData);
                        handleChangeModalContent(
                            setCreateContent,
                            `CREAR ACTIVIDAD - ${auth.selectedEstablishment.name}`
                        );
                    }}
                >
                    Crear actividad
                </Button>
            </Grid>
            <Grid item xs={12}>
                <FilterBar
                    labelSearch="Buscar actividad"
                    columnVisibilityModel={columnVisibilityModel}
                    onPageChange={getActivities}
                    openLoader={openLoader}
                    rowCount={rowCount}
                    columns={activitiesColumns}
                    rows={activities}
                    pageSize={pageSize}
                    enableExtraFilter
                    extraFilterList={extraFilterList}
                    extraFilterComponent={extraFilterComponent}
                    extraFilterCallback={extraFilterCallback}
                    component={
                        extraFilter.visibility === VISIBILITY.community
                            ? componentEstablishmentFilterBar
                            : undefined
                    }
                />
            </Grid>
            <GenericDialog
                title={modalTitle}
                open={openDialog}
                mandatoryText={!deleteContent && !assignedInContent && !showContent}
                setOpen={setOpenDialog}
                cancelButton={showCancelButtonDialog}
                saveButton={showSaveButtonDialog}
                saveButtonText={deleteContent ? "Sí" : "Guardar"}
                handleSave={
                    assignContent
                        ? handleAssignCourse
                        : createContent
                        ? handleCreateActivity
                        : updateContent
                        ? handleCreateActivity
                        : deleteContent
                        ? handleDeleteActivity
                        : handleCloneActivity
                }
            >
                <DialogContent>
                    {createContent && (
                        <DialogContentCreate
                            activityFormData={activityFormData}
                            setActivityFormData={setActivityFormData}
                        />
                    )}
                    {updateContent && (
                        <DialogContentCreate
                            activityFormData={activityFormData}
                            setActivityFormData={setActivityFormData}
                            editableMode={editableMode}
                        />
                    )}
                    {cloneContent && (
                        <DialogContentClone
                            activityCloneFormData={activityCloneFormData}
                            setActivityCloneFormData={setActivityCloneFormData}
                            selectedActivity={selectedActivity}
                        />
                    )}
                    {assignContent && (
                        <DialogContentAssign
                            selectedCourse={selectedCourse}
                            setSelectedCourse={setSelectedCourse}
                            setActivityFormData={setActivityFormData}
                            assignCourseFormData={assignCourseFormData}
                            setAssignCourseFormData={setAssignCourseFormData}
                        />
                    )}
                    {showContent && (
                        <DialogContentClone
                            activityCloneFormData={activityCloneFormData}
                            setActivityCloneFormData={setActivityCloneFormData}
                            selectedActivity={selectedActivity}
                            showEditableButton={false}
                        />
                    )}
                    {deleteContent && (
                        <div>
                            ¿Está seguro de que desea eliminar esta actividad?
                            {selectedActivity?.deleteInformation?.course_list.length > 0 && (
                                <div>
                                    <br />
                                    La actividad que desea eliminar esta asignada sin entregas ni
                                    correcciones en los siguientes cursos:
                                    <br />
                                    <ul>
                                        {selectedActivity.deleteInformation?.course_list.map(
                                            (item, index) => (
                                                <li key={index}>{item}</li>
                                            )
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>
                    )}
                    {assignedInContent && (
                        <DialogContentAssignedIn selectedActivity={selectedActivity} />
                    )}
                </DialogContent>
            </GenericDialog>

            {showAlert && (
                <Grid
                    sx={{
                        position: "fixed",
                        top: "50%",
                        left: "40%",
                        zIndex: 99999,
                    }}
                >
                    <GenericAlert severity={severity} text={alertText}></GenericAlert>
                </Grid>
            )}

            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 3,
                }}
                open={openLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Grid>
    );
};

export default ActivitiesList;
